import authAxios from 'modules/shared/axios/authAxios';
import Axios from 'axios';

export default class ReleaseService {
  static async update(id, data) {

    const body = {
      id,
      data
    };

    const response = await authAxios.put(
      `/terminalUiRelease/${id}`,
      body,
    );

    return response.data;
  }

  static async destroyAll(ids) {
    const params = {
      ids,
    };

    const response = await authAxios.delete(`/terminalUiRelease`, {
      params,
    });

    return response.data;
  }

  static async create(data) {
    const body = {
      data
    };

    const response = await authAxios.post(
      `/terminalUiRelease`,
      body,
    );

    return response.data;
  }

  static async import(values, importHash) {
    const body = {
      data: values,
      importHash,
    };

    const response = await authAxios.post(
      `/terminalUiRelease/import`,
      body,
    );

    return response.data;
  }

  static async find(id) {
    const response = await authAxios.get(`/terminalUiRelease/${id}`);
    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };
    const response = await authAxios.get(`/terminalUiRelease`, {
      params,
    });

    return response.data;
  }

  static async listAutocomplete(query, limit) {
    const params = {
      query,
      limit,
    };

    const response = await authAxios.get(
      `/terminalUiRelease/autocomplete`,
      {
        params,
      },
    );

    return response.data;
  }
  
  static async listCascader(query, limit) {
    const params = {
      query,
      limit,
    };

    const response = await authAxios.get(
      `/terminalUiRelease/cascader`,
      {
        params,
      },
    );

    return response.data;
  }
}
